module.exports = __webpack_public_path__ + "img/icon-flag-ua.627ef713.svg";